import { Link } from "@/lib/router-compat";

import JaikLogo from "@/components/agency/JaikLogo";

const trades: [string, string][] = [
  ["Roofing web design", "/contractor-websites/roofing-contractors"],
  ["Plumber web design", "/contractor-websites/plumbing-contractors"],
  ["HVAC web design", "/contractor-websites/hvac-contractors"],
  ["Electrician web design", "/contractor-websites/electrical-contractors"],
  ["Remodeling web design", "/contractor-websites/remodeling-contractors"],
  ["General contractor web design", "/contractor-websites/general-contracting-contractors"],
  ["Landscaping web design", "/contractor-websites/landscaping-contractors"],
  ["Painting contractor web design", "/contractor-websites/painting-contractors"],
];

const cities: [string, string][] = [
  ["Seattle", "/contractor-websites/seattle"],
  ["Bellevue", "/contractor-websites/bellevue"],
  ["Kent", "/contractor-websites/kent"],
  ["Renton", "/contractor-websites/renton"],
  ["Tacoma", "/contractor-websites/tacoma"],
  ["Everett", "/contractor-websites/everett"],
  ["Kirkland", "/contractor-websites/kirkland"],
  ["Federal Way", "/contractor-websites/federal-way"],
  ["Auburn", "/contractor-websites/auburn"],
  ["Redmond", "/contractor-websites/redmond"],
];

const AgencyFooter = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="border-t border-agency-border py-10">
      <div className="container flex flex-col gap-6">
        <div className="grid gap-8 sm:grid-cols-2 border-b border-agency-border pb-8">
          <nav aria-label="Web design by trade">
            <h2 className="font-heading text-sm font-bold uppercase tracking-wide text-agency-text mb-3">Web design by trade</h2>
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-2">
              {trades.map(([label, href]) => (
                <li key={href}>
                  <Link to={href} className="font-sans text-sm text-agency-text-muted hover:text-agency-text transition-colors">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
          <nav aria-label="Web design by city">
            <h2 className="font-heading text-sm font-bold uppercase tracking-wide text-agency-text mb-3">Web design by city</h2>
            <ul className="grid grid-cols-2 gap-x-4 gap-y-2">
              {cities.map(([label, href]) => (
                <li key={href}>
                  <Link to={href} className="font-sans text-sm text-agency-text-muted hover:text-agency-text transition-colors">
                    Contractor web design in {label}
                  </Link>
                </li>
              ))}
            </ul>
            <Link to="/king-county-contractors" className="inline-block mt-3 font-sans text-sm text-agency-accent hover:underline">
              See the full service area
            </Link>
          </nav>
        </div>
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <button
            onClick={scrollToTop}
            className="font-heading text-lg font-bold tracking-tight text-agency-text cursor-pointer bg-transparent border-none"
          >
            <JaikLogo />
          </button>
          <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6">
            <Link to="/contractor-websites" className="font-sans text-sm text-agency-text-muted hover:text-agency-text transition-colors">Web design</Link>
            <Link to="/contractor-seo" className="font-sans text-sm text-agency-text-muted hover:text-agency-text transition-colors">SEO</Link>
            <Link to="/pricing" className="font-sans text-sm text-agency-text-muted hover:text-agency-text transition-colors">Pricing</Link>
            <Link to="/blog" className="font-sans text-sm text-agency-text-muted hover:text-agency-text transition-colors">Blog</Link>
            <Link to="/king-county-contractors" className="font-sans text-sm text-agency-text-muted hover:text-agency-text transition-colors">King County</Link>
            <Link to="/contact" className="font-sans text-sm text-agency-text-muted hover:text-agency-text transition-colors">Contact</Link>
          </div>
        </div>
        <div className="flex flex-col md:flex-row items-center justify-between gap-3 border-t border-agency-border pt-6">
          <p className="font-sans text-xs text-agency-text-muted/60">
            © {new Date().getFullYear()} jaik. All rights reserved. Seattle, WA.
          </p>
          <div className="flex items-center gap-4">
            <Link to="/privacy" className="font-sans text-xs text-agency-text-muted/60 hover:text-agency-text-muted transition-colors">Privacy</Link>
            <Link to="/terms" className="font-sans text-xs text-agency-text-muted/60 hover:text-agency-text-muted transition-colors">Terms</Link>
            <Link to="/choices" className="font-sans text-xs text-agency-text-muted/60 hover:text-agency-text-muted transition-colors">Your Privacy Choices</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default AgencyFooter;
